/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './activateAccount.defs'
export { main as default } from './activateAccount.defs'
